"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition(curvePoints) {
    const prefix = "point";
    const createDefinition = (name, group, quantity, sortNo) => ({
        sort_no: sortNo,
        name: name,
        group: group,
        quantity: quantity,
        validation_filter: property_1.PropertyFilter.Empty,
        visibility_filter: property_1.PropertyFilter.Empty,
        value: []
    });
    const createGroup = (point) => {
        return [
            createDefinition(prefix + point + "airflow", prefix + point, "VolumeFlow", 1),
            createDefinition(prefix + point + "pressure", prefix + point, "Pressure", 2),
            createDefinition(prefix + point + "shaftpower", prefix + point, "Power", 3)
        ];
    };
    return new Array(curvePoints)
        .fill(0)
        .reduce((a, _b, ix) => a.concat(createGroup(ix + 1)), []);
}
//# sourceMappingURL=fancurve-definition.js.map